/* eslint-disable @repo/internal/react/require-jsdoc */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { ReactNode } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css, jsx } from '@emotion/react';

import { Box, xcss } from '@atlaskit/primitives';
import { useThemeObserver } from '@atlaskit/tokens';

import illustrationDark from './_assets/illustration-dark.svg';
import illustrationLight from './_assets/illustration-light.svg';

const bottomBarStyles = xcss({
	width: '100%',
	backgroundColor: 'color.background.neutral.bold',
	paddingInlineStart: 'space.400',
});

export const Bookend = ({ children }: { children: ReactNode }) => {
	const { colorMode = 'light' } = useThemeObserver();
	return (
		<Box xcss={bottomBarStyles}>
			<Grid>
				{children}
				<BackgroundSVG src={colorMode === 'light' ? illustrationLight : illustrationDark} />
			</Grid>
		</Box>
	);
};

const gridStyles = xcss({
	display: 'grid',
	gridTemplateColumns: '1fr',
	'@media (min-width: 48rem)': {
		gridTemplateColumns: '1fr 1fr',
	},
});

const Grid = ({ children }: { children: ReactNode }) => {
	return <Box xcss={gridStyles}>{children}</Box>;
};

const bgStyles = css({
	backgroundPositionY: '100%',
	backgroundRepeat: 'no-repeat',
	backgroundSize: 'contain',
});

const BackgroundSVG = ({ src }: { src: string }) => {
	return <span css={bgStyles} style={{ backgroundImage: `url(${src})` }}></span>;
};
